import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button, TextInput } from '@/components/ui/daisy';
import { CreateCourseModule } from '@/data/services/courseModuleServices';

type ModuleInlineFormFields = {
  name: string;
};

type ModuleInlineFormProps = {
  onSubmit: (data: CreateCourseModule) => void;
  onCancel: () => void;
  isLoading?: boolean;
  order: number;
};

export default function ModuleInlineForm({
  order,
  onSubmit,
  onCancel,
  isLoading,
}: ModuleInlineFormProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.moduleForm.form',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ModuleInlineFormFields>({
    defaultValues: {
      name: '',
    },
  });

  const handleFormSubmit = (data: ModuleInlineFormFields) => {
    onSubmit({
      name: data.name,
      order,
    });
  };

  return (
    <FieldsetContainer>
      <form
        className="flex flex-col gap-4"
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <TextInput.Fieldset
          label={t('moduleName')}
          labelAlt={errors?.name?.message}
        >
          <TextInput
            type="text"
            placeholder={t('moduleNamePlaceholder')}
            className="w-full"
            color={!errors?.name?.message ? 'default' : 'error'}
            {...register('name', { required: t('moduleNameRequired') })}
          />
        </TextInput.Fieldset>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            className="grow bg-base-300"
            onClick={onCancel}
            disabled={isLoading}
          >
            {t('cancel')}
          </Button>
          <Button
            type="submit"
            color="secondary"
            className="grow"
            disabled={isLoading}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </FieldsetContainer>
  );
}
